import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import { FOOTER_HEIGHT, SIDE_NAV_OPENED_WIDTH } from '../SideNavigation.constants.js';
import { StyledSubMenu } from '../SideNavigationSubMenu/SideNavigationSubMenu.styles.js';

var _templateObject, _templateObject2, _templateObject3, _templateObject4;
var getSubMenuVisibility = function getSubMenuVisibility(_ref) {
  var $subMenuOffsetTop = _ref.$subMenuOffsetTop;
  return $subMenuOffsetTop === 0 ? 'hidden' : 'visible';
};
var getAnchorBackgroundColour = function getAnchorBackgroundColour(_ref2) {
  var $isSelected = _ref2.$isSelected,
    $isTouch = _ref2.$isTouch,
    $isSubmenuOpen = _ref2.$isSubmenuOpen,
    theme = _ref2.theme;
  if ($isTouch && $isSubmenuOpen) return theme.colours.navigation.primary.main;
  if ($isSelected) return theme.applyOpacity(theme.colours["interface"].main, 'highlight');
  return theme.colours.navigation.primary.main;
};
var getMenuItemDisplay = function getMenuItemDisplay(_ref3) {
  var $isTouch = _ref3.$isTouch,
    $menuItemId = _ref3.$menuItemId,
    $selectedSubmenu = _ref3.$selectedSubmenu;
  if ($isTouch && ($selectedSubmenu === $menuItemId || $selectedSubmenu === null)) return 'block';
  if ($isTouch && $selectedSubmenu !== $menuItemId) return 'none';
  return 'block';
};
var Anchor = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  background: ", ";\n  color: ", ";\n  container-type: inline-size;\n  cursor: pointer;\n  display: flex;\n  gap: ", ";\n  padding: ", ";\n  width: 100%;\n\n  // This is for styling the anchor used in the side nav footer.\n  &:has(> span) {\n    height: ", ";\n  }\n\n  &:hover {\n    background: ", ";\n    color: ", ";\n  }\n"])), getAnchorBackgroundColour, function (_ref4) {
  var theme = _ref4.theme,
    $isSelected = _ref4.$isSelected;
  return $isSelected ? theme.colours.navigation.primary.ink : theme.applyOpacity(theme.colours.navigation.primary.ink, 'secondary');
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.sizing.medium;
}, function (_ref6) {
  var theme = _ref6.theme;
  return "".concat(theme.sizing.regular, " ").concat(theme.sizing.medium);
}, FOOTER_HEIGHT, function (_ref7) {
  var theme = _ref7.theme,
    $isSelected = _ref7.$isSelected;
  return !$isSelected ? theme.colours.navigation.primary.strong : undefined;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colours.ink.primary.main;
});
var StyledMenuItem = styled.li(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  list-style: none;\n  position: relative;\n  display: ", ";\n\n  &:hover {\n    ", " {\n      visibility: ", ";\n      left: ", ";\n\n      ", " {\n        background: ", ";\n      }\n    }\n  }\n"])), getMenuItemDisplay, StyledSubMenu, function (_ref9) {
  var $isTouch = _ref9.$isTouch,
    $subMenuOffsetTop = _ref9.$subMenuOffsetTop;
  return !$isTouch && getSubMenuVisibility({
    $subMenuOffsetTop: $subMenuOffsetTop
  });
}, function (_ref10) {
  var $isTouch = _ref10.$isTouch;
  return !$isTouch && SIDE_NAV_OPENED_WIDTH;
}, Anchor, function (_ref11) {
  var theme = _ref11.theme;
  return theme.colours.navigation.primary.strong;
});
var SelectedBar = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background-color: ", ";\n  height: 100%;\n  left: 0;\n  position: absolute;\n  width: ", ";\n"])), function (_ref12) {
  var theme = _ref12.theme;
  return theme.colours["interface"].main;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.sizing.tiny;
});
var StyledMenuItemText = styled.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: inherit;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  visibility: hidden;\n  /* Ensure the menu text is only visible when the container's width is greater than 3.5rem.\n     The anchor component has padding of theme.sizing.medium (1rem) on each side.\n     This is why the min-width is 1.51rem.  */\n  @container (min-width: 1.51rem) {\n    visibility: visible;\n  }\n"])));

export { Anchor, SelectedBar, StyledMenuItem, StyledMenuItemText };
//# sourceMappingURL=SideNavigationMenuItem.styles.js.map
